@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<mat-card appearance="outlined">
    <mat-card-content>
        {{object?.Bezeichnung}} 
         @if(this.getObjektistErledigt(object)){<mat-icon >check</mat-icon>}
    </mat-card-content>
</mat-card>

<mat-accordion>
    @for(roofArea of roofAreaList; track roofArea.roofArea.Bezeichnung){
    <mat-expansion-panel [(expanded)]="roofArea.panelOpen">
        <mat-expansion-panel-header>
            <mat-panel-title style="flex:1;">{{roofArea.roofArea.Bezeichnung}}
                 @if(this.getRoofareayistErledigt(roofArea)){<mat-icon >check</mat-icon>}
            </mat-panel-title>           
            <mat-panel-description >{{roofArea.roofArea.Longitude}},
                {{roofArea.roofArea.Latitude}}</mat-panel-description>
        </mat-expansion-panel-header>

        @for(safetyPoint of roofArea.safetyPointList; track safetyPoint.SafetyPointId){
        <mat-card appearance="outlined" (click)="openSafetyPointServiceDialog(safetyPoint)">

            <mat-card-content>
                <mat-list>
                    <mat-list-item class="safetyBez" style="display: flex;">{{safetyPoint.Bezeichnung}}                        
                        @if(safetyPoint.Erledigt){<mat-icon >check</mat-icon>}
                    </mat-list-item>
                    <mat-list-item>{{language.Sicherungssystem | translationPipe}}: {{safetyPoint.SicherungssystemBezeichnung}}</mat-list-item>
                    <mat-list-item>{{language.Longitude | translationPipe}}: {{safetyPoint.Longitude}}</mat-list-item>
                    <mat-list-item>{{language.Latitude | translationPipe}}: {{safetyPoint.Latitude}}</mat-list-item>
                </mat-list>
                <doc-documents [documentList]="getDokumentList(safetyPoint)" [disabled]="true" [maxImageAmount]="getDokumentList(safetyPoint).length"></doc-documents>
            </mat-card-content>
        </mat-card>
        }
    </mat-expansion-panel>
    }
</mat-accordion>